import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchLabel: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filters.search-filter.search-label',
		defaultMessage: 'Search pull requests by title.',
		description: 'Label associated to a search box that filters a table of pull requests',
	},
	searchInputPlaceHolderText: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filters.search-filter.search-input-place-holder-text',
		defaultMessage: 'Search pull requests',
		description: 'Placeholder text associated to a search box',
	},
	searchCurrentPage: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filters.search-filter.search-current-page',
		defaultMessage: 'Search on current page',
		description: 'Command in the command palette to trigger the page search',
	},
});
